module.exports = require("././ui-bootstrap-tpls.js");


//////////////////
// WEBPACK FOOTER
// angular-bootstrap (bower component)
// module id = 115
// module chunks = 0